import { Button, CardActions, CardContent, CardMedia, Grid, Theme, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import adventCalendarImg from "assets/images/paps-gift.png";
import useText from "constants/text";
import GiftDialog from "domains/Gift/components/GiftDialog";
import { useCurrentClient, useCurrentUser } from "hooks";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getLocalGift } from "utils";
import Card from "../components/Card";
import { useCards } from "../data";
import home_illustration from "../../../assets/images/home_illustration.svg";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      position: "absolute",
      top: 0
    },
    sectionOne: {
      height: "40vh",
      textAlign: "center",
      backgroundColor: "#1B224A",
      paddingTop: 60,
    },
    welcomeMessage: {
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
    },
    hello: {
      color: "#ffff",
      fontWeight: 500,
      fontSize: 24,
      [theme.breakpoints.down("xs")]: {
        display:"none"
         },
    },
    message: {
      color: "#ffff",
      fontWeight: 500,
      fontSize: 24,
      [theme.breakpoints.down("xs")]: {
        display:"none"
         },
    },
    subMessage: {
      color: "#ffff",
      fontWeight: 400,
      fontSize: 15,
      marginTop: -3,
      [theme.breakpoints.down("xs")]: {
        display:"none"
         },
    },
    sectionTwo: {
      display: "flex",
      justifyContent: "center",
      gap: "120px 0px",
      alignSelf: "center",
      flexWrap: "wrap",
      marginTop: -15,
      [theme.breakpoints.down("xs")]: {
       marginTop:-50
      },
    },
    card: {
      height: 250,
      width: 350,
      position: "relative",
      background: "white",
      margin: 20,
      border: "1px solid #757a93",
      borderRadius: 20,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "0px 20px 0px 20px",
    },
    cardHeader: {
      height: 105,
      width: 105,
      borderRadius: "50%",
      display: "flex",
      marginTop: -50,
      background: "#f9f9f9",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: 5,
    },
    cardSubHeader: {
      border: "1px solid #757a93",
      height: 90,
      width: 90,
      borderRadius: "50%",
    },
    cardBody: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: 320,
      position: "relative",
      top: -3,
    },
    bodyLabel: {
      color: "#f2994a",
      fontWeight: 600,
      fontSize: 16,
      marginTop: 20,
    },
    description: {
      width: "315px",
      height: "63px",
      marginTop: -4,
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#757a93",
      lineHeight: 1.5,
    },
    disabled: {
      opacity: "41%",
      "&.MuiButton-contained": {
        color: "#fff",
        backgroundColor: "#399ebf",
      },
    },
    button: {
      width: "15em",
      height: "30px",
      position: "relative",
      bottom: -10,
      [theme.breakpoints.down("xs")]: {
        width: "20em",
      },
    },
    img: {
      position: "absolute",
      bottom: -200,
      width: "100%",
      zIndex: -1,
      [theme.breakpoints.down("xs")]: {
        width: "30em",
      },
    },
  })
);
export const HomePage = () => {
  const classes = useStyles();
  const navigator = useNavigate();
  const { user } = useCurrentUser();
  const { client } = useCurrentClient();
  const { text } = useText();
  const cards = useCards(text, client);
  const [openGiftDialog, setOpenGiftDialog] = React.useState(false);

  React.useEffect(() => {
    const localGift = getLocalGift();
    if (process.env.REACT_APP_PAPS_GIFT && localGift && localGift === new Date().getDate()) {
      setOpenGiftDialog(true);
    }
  }, []);

  const openOrCloseGiftDialog = () => {
    setOpenGiftDialog(!openGiftDialog);
  };
  const navigateToGiftCalendar = () => {
    navigator("/gifts");
  };

  return (
    <div className={classes.root}>
      <section className={classes.sectionOne}>
        <div className={classes.welcomeMessage}>
          <p className={classes.hello}>{text.all.hello}, &nbsp;</p>
          <p className={classes.message}>
            {user?.company_user_firstname}, &nbsp; {text.all.from} &nbsp; {client?.client_company_name}
          </p>
        </div>
        <p className={classes.subMessage}>{text.all.what_can_we_do_for_you_today}</p>
      </section>

      <section className={classes.sectionTwo}>
        {cards.map((item) => (
          <Card item={item} />
        ))}

        <img src={home_illustration} className={classes.img} alt="Home illustration" />
      </section>

      <GiftDialog
        open={openGiftDialog}
        image={adventCalendarImg}
        onConfirm={navigateToGiftCalendar}
        onClose={openOrCloseGiftDialog}
      />
    </div>
  );
};

export default HomePage;
